export default {
  minVideoDurationForMidRollAd: 600,
  adOffsets: {
    overlay: 5,
    mid: 300,
  },
  subscriberDisabledAds: ['pre', 'mid', 'post', 'overlay', 'no_skip'],
};
